<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Form ref="newForm"
          :model="step1"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <div class="padding-top-20"></div><div class="padding-top-20"></div>
          <FormItem label="所在区域" prop="cityId" style="width:100%">
            <Cascader v-model="step1.cities" :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择"></Cascader>
          </FormItem>
          <div class="padding-top-20"></div><div class="padding-top-20"></div>
        </Form>
        </vue-scroll>
      </div>
      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="16" offset="4"><Button type="primary" size="large" long @click="submit">下一步</Button></Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new',
  props: {
  },
  data () {
    return {
      loading: false,
      step1: {
        cityId: null,
        cities: [],
        guarantorCity: null
      },
      modelValidate: {
        cityId: [
          { required: true, type: 'number', message: '请选择区域', trigger: 'blur' }
        ]
      },
      cities: [],
      myCities: []
    }
  },
  watch: {
  },
  mounted () {
    this.getMyPermittedCities().then(() => {
      this.initCitySelect()
    })
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getMyPermittedCities () {
      return new Promise((resolve, reject) => {
        Api.Guarantor.getMyPermittedCities().then((cities) => {
          this.myCities = cities
          resolve(cities)
        }).catch(err => {
          this.$Message.error('获取城市列表失败!' + err.message)
          reject(err)
        })
      })
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = []
        cities.data.forEach((c) => {
          let exists = this.myCities.find(o => o.cityId === c.tid)
          if (exists) {
            if (tier === 1) {
              // 地市
              data.push({
                id: c.tid,
                value: c.tid,
                label: c.name,
                tier: c.tier,
                parent: c.parent,
                loading: false,
                children: []
              })
            } else {
              data.push({
                value: c.tid,
                label: c.name,
                tier: c.tier,
                parent: c.parent
              })
            }
          } else {
            let parentExists = this.myCities.find(o => o.cityId === c.parent)
            if (parentExists) {
              if (tier === 1) {
                // 地市
                data.push({
                  id: c.tid,
                  value: c.tid,
                  label: c.name,
                  tier: c.tier,
                  parent: c.parent,
                  loading: false,
                  children: []
                })
              } else {
                data.push({
                  value: c.tid,
                  label: c.name,
                  tier: c.tier,
                  parent: c.parent
                })
              }
            }
            
          }
        })
        let retData = []
        if (tier > 1) {
          retData.push({
            value: parentId,
            label: '本级'
          })
        } else if (tier === 1) {
          retData.push({
            value: parentId,
            label: '本级'
          })
        }
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        if (callback) {
          callback()
        }
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        if (callback) {
          callback()
        }
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.step1.cityId = val[val.length - 1]
      } else {
        this.step1.cityId = val
      }
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.step1.guarantorCity = this.cities.filter((p) => {
            return p.children.filter((c) => {
              if (!c.children) {
                return c.cityId === this.step1.cityId
              } else {
                return c.children.filter((d) => {
                  return d.cityId === this.step1.cityId
                })
              }
            })
          })
          // this.step1.guarantorCity = this.myCities.filter((c) => {
          //   return c.cityId === this.step1.cityId
          // })
          this.$emit('finish-step1', this.step1)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {

  }
}
</style>
